import { DiaperCalculatorApp } from './diaper-calculator-app'

export default DiaperCalculatorApp
